type RecencyPrefill = { lastOrderShippingMethod?: string | null; lastOrderShippingMethods?: string[] | null } | null | undefined;

export const pickPreselectedShippingMethod = (prefill: RecencyPrefill, isOffered: (method: string) => boolean): string | undefined =>
  prefill?.lastOrderShippingMethods?.find(isOffered) ?? prefill?.lastOrderShippingMethod ?? undefined;
